export const STRINGS = {
    USER_MANAGEMENT_TITLE: "Users",
    USER_MANAGEMENT_FUNCTIONALITY_TITLE: "Add and manage your users and their roles",
    ADD_USER_BUTTON: "Add User",
    INVITE_USER_MODAL_TITLE: "Invite User",
    EMAIL_LABEL: "Email ID",
    NAME_LABEL: "Name",
    MOBILE_NUMBER_LABEL: "Mobile Number",
    ROLE_LABEL: "Role",
    INVITE_BUTTON: "Invite",
    CANCEL_BUTTON: "Cancel",
    FAQS: "FAQs",
    INVITE_NEW_USER: "To invite a new user, click ‘Add User’.",
    NO_DEACTIVATED_USER_MESSAGE: "You don’t have any deactivated users. To invite a new user, click ‘Add User’.",
    NO_INVITED_USER_MESSAGE: "You don’t have any invited users. To invite a new user, click ‘Add User’.",
    NO_ACTIVE_USER_MESSAGE: "You don’t have any other users. To invite a new user, click ‘Add User’.",
    INVITE_USERS: "Invite users to ",
    INVITE_VALID_MESSAGE: "Invite is valid for 14 days.",
    CREATE_INVITE_LINK: "Create invite Link",
    ENTER_USERNAME: "Enter user's name",
    ENTER_NUMBER: "Enter user's mobile number",
    ENTER_EMAIL: "Enter user's email",
    INVITE_AS: "Invite as",
    EMPTY_USERNAME_ERROR_MESSAGE: "Name should not be empty",
    INVALID_USERNAME_ERROR_MESSAGE: "Name should not contain numbers or special characters",
    EMPTY_MOBILE_NUMBER_ERROR_MESSAGE: "Mobile number should not be empty",
    INVALID_MOBILE_NUMBER_ERROR_MESSAGE: "Enter valid mobile number",
    EMPTY_EMAIL_ERROR_MESSAGE: "Email ID should not be empty",
    INVALID_EMAIL_ERROR_MESSAGE: "Enter a valid email ID",
    STORE_DETAILS_ERROR_MESSAGE: "Error in Fetching Store Details",
    USER_ACCESS_TOOLTIP_CONTENT: "All users have same access!",
    ROLE_TOOLTIP_CONTENT: "More roles coming soon!",
    MODAL: "Modal",
    SHEET: "Sheet",
    COPY_INVITE_LINK: "Copy Invite Link",
    INVITE_LINK_FOR:  "Invite link for",
    COPIED_TO_CLIPBOARD: "copied to clipboard.",
    CANCEL_INVITE_MESSAGE: "Invite revoked for ",
    DEACTIVATE_USER_MESSAGE: "Deactivated user: ",
    ACCEPT_INVITE_SUCCESS: "Invitation accepted successfully! Redirecting to homepage...",
    REDIRECTING:  "Redirecting...",
    ACCEPT_INVITE_FAILURE: "Unable to Process Invitation",
    ACCEPT_INVITE_PROCESSING: "Processing invitation...",  
    STAFF_GET_COMPLETE_ACCESS: "Staff users get complete access.",
    OLD_INCORRECT_MOBILE_ERROR_MESSAGE: "Mobile number used for signup is not same with the invited mobile number",
    NEW_INCORRECT_MOBILE_ERROR_MESSAGE: "The phone number you're using to sign up doesn't match the one associated with your invitation",
    CONTACT_STORE_OWNER_MESSAGE: "Please use the phone number shared with you for the invitation. If you think this is a mistake, contact the store owner to verify the details or request a new invitation.",
    INVITED_AS_STAFF:"has invited you as a Staff to",
    JOIN_STORE: "Join store",
    GET_SUPPORT: "Get Support",
    YEAR: "© 2024 - 2025 Amazon Smartbiz",
    JOIN: "Join",
    APP_LOGO : "https://m.media-amazon.com/images/G/31/smartcommerce/website/smartbiz-logo-nav.svg",
    LOADING : "Loading..."
};

export enum ACTIONS {
    MANAGE = 'Manage',
    REVOKE = 'Revoke',
    DEACTIVATE = 'Deactivate',
    COPY = 'Copy invite link',
    ACTIVATE = 'Activate',
    INVITE_AGAIN = "Invite again"
}

export enum USER_LIST_HEADERS {
    USER = 'User',
    ROLE = 'Role',
    LAST_SIGNED_IN = 'Last signed in',
    STATUS = 'Status',
    ACTIONS = 'Actions',
}

export enum FORM_LABELS {
    NAME = 'name',
    EMAIL = 'email',
    MOBILE_NUMBER = 'mobileNumber',
}

export const USER_STATUS_PRIORITY = {
    ACTIVE: 1,
    PENDING: 2,
    EXPIRED: 3,
    CANCELLED: 4,
}